import React, { useState, useEffect } from 'react';
import KnowledgeAndSkillsModuleCard from 'components/Cards/KnowledgeAndSkillsModuleCard';
import ToggleDetail from 'components/ToggleDetail';
import KnowledgeAndSkillsFormWrapper from 'components/Forms/KnowledgeAndSkillsFormWrapper';
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import { get } from 'services';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import WarningNotiifcation from 'components/WarningNotification';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const KnowledgeAndSkillsModule = ({user}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(true);
  const [competencias, setCompetencias] = useState([]);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)
        const response = await get(`PersonaConocimiento/GetByPersonaId/${user.persona.id}`)
        user.persona.personaConocimientos = response.data

        if (user.persona.personaConocimientos && user.persona.personaConocimientos.length > 0 && user.persona.personaConocimientos.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        const data = await get(`Conocimiento`);
        setCompetencias(data.data);
      } catch (error) {
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail}  onToggleDetail={setShowDetail} label="Conocimientos y habilidades"/>
        { 
          showDetail ? 
          <div> 
            {
              
              (user.persona && user.persona.personaConocimientos && user.persona.personaConocimientos.length > 0 && user.persona.personaConocimientos.filter(x => x && x.estado == 1).length > 0) 
                ? (
                  user.persona.personaConocimientos.filter(x => x && x.estado == 1).map((competencia) => {
                    return <KnowledgeAndSkillsModuleCard key={competencia.id} competencia={competencia} competencias={competencias}/>
                  })
                )
                : <Form.Group as={Col} md="12">
                <WarningNotiifcation message='No ha agregado  ' enphasis='competencias y habilidades'/>
              </Form.Group>
            }
            <Navigation beforeUrl="/talents" continueUrl="/experience" />
          </div>
          : 
          <div> 
            <KnowledgeAndSkillsFormWrapper />
          </div>
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

export default connect(mapStateToProps)(KnowledgeAndSkillsModule);